import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ScholarshipService } from 'src/app/private/services/scholarship.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-delete-scholarship',
  imports: [SharedModule],
  templateUrl: './delete-scholarship.component.html',
  styleUrl: './delete-scholarship.component.scss'
})
export class DeleteScholarshipComponent {

  @Output() closeDialog = new EventEmitter<any>();
  @Input() scholarshipData: any;
  @Output() reload = new EventEmitter<any>();
  isLoading = false;

  constructor(
    private api: ScholarshipService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) {}

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  handleDelete() {
    this.isLoading = true;

    const payload = {
      id: this.scholarshipData.id,
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    }

    this.api.deleteScholarship(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.messageService.add({
          severity: 'success', 
          summary: 'Success', 
          detail: 'Scholarship deleted successfully'
        });
        this.closeDialog.emit();
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error', 
          summary: 'Error', 
          detail: 'Failed to delete scholarship'
        });
        this.isLoading = false;
      }
    });
  }
}